// ----------------------------------------------------------------------

export function textField(theme) {
  return {
    MuiTextField: {
      styleOverrides: {
        root: {
          // Custom form field styling (replacing .usrFrmFld styles)
          '& .MuiOutlinedInput-root': {
            backgroundColor: theme.palette.background.paper,
            borderRadius: theme.spacing(1),
            transition: theme.transitions.create(['border-color', 'background-color']),
            
            '&:hover': {
              backgroundColor: theme.palette.mode === 'light' 
                ? 'rgba(145, 158, 171, 0.08)' 
                : theme.palette.grey[800],
            },
            
            '&.Mui-focused': {
              backgroundColor: theme.palette.background.paper,
            },
            
            '& fieldset': {
              borderColor: theme.palette.grey[300],
            },
            
            '&:hover fieldset': {
              borderColor: theme.palette.text.primary,
            },
            
            '&.Mui-focused fieldset': {
              borderColor: theme.palette.primary.main,
              borderWidth: '1px',
            },
          },
          
          // Disabled state styling
          '& .MuiOutlinedInput-root.Mui-disabled': {
            backgroundColor: theme.palette.background.paper,
            opacity: 1,
            
            '& .MuiOutlinedInput-input': {
              color: theme.palette.text.primary,
              WebkitTextFillColor: theme.palette.text.primary,
            },
          },
          
          // Input padding and sizing
          '& .MuiOutlinedInput-input': {
            padding: theme.spacing(1.5, 1.8),
          },
          
          // Label styling
          '& .MuiInputLabel-root': {
            transform: 'translate(14px, 16px) scale(1)',
            
            '&.MuiInputLabel-shrink': {
              transform: 'translate(14px, -9px) scale(0.75)',
            },
          },
        },
      },
    },
    
    // Filled variant styling (replacing .fuWdt styles)
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: `${theme.palette.background.paper} !important`,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: theme.spacing(1),
          
          '&:hover': {
            backgroundColor: `${theme.palette.background.paper} !important`,
            borderColor: theme.palette.text.primary,
          },
          
          '&.Mui-focused': {
            backgroundColor: `${theme.palette.background.paper} !important`,
            borderColor: theme.palette.primary.main,
          },
          
          '&:before, &:after': {
            display: 'none',
          },
        },
      },
    },
  };
} 